import api from "./api"

export const searchSimulationData = async (filterParams) => {
  try {
    const response = await api.get("/api/simulator/search", {
      params: filterParams,
      // FastAPI가 인식할 수 있도록 배열 파라미터를 직렬화 (?key=a&key=b)
      paramsSerializer: (params) => {
        const searchParams = new URLSearchParams()
        Object.keys(params).forEach((key) => {
          const value = params[key]
          if (Array.isArray(value)) {
            value.forEach((v) => searchParams.append(key, v))
          } else if (value !== null && value !== undefined && value !== "") {
            searchParams.append(key, value)
          }
        })
        return searchParams.toString()
      }
    })
    return response.data
  } catch (error) {
    console.error("Simulation Search Error:", error)
    throw error
  }
}
